<template>
  <div class="w-100 d-flex flex-column justify-center" style="padding: 5px">
    <h4 v-if="informacionElemento.tipo">
      Aplicaciones de {{this.informacionElemento.tipo}}
    </h4>

    <h4 v-else></h4>
    
    <div class="d-flex flex-row flex-wrap">
      <form v-for="(boton, index) in appsCliente" :key="index">
        <IconButton
          @click.prevent="abrirPestana(aplicacionesCliente[index].url)"
          :titleButtom="boton.nombre"
          :icon="boton.icon"
          :backgroundColor="boton.color"
          :parametros="boton.post"
          :urlAction="boton.url"
          heightButton="75px"
          widthButton="75px"
          fontSize="55px"
        />
      </form>
    </div>
  </div>
</template>

<script>
import IconButton from "../components/common/IconButton.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { Fragment } from "vue-fragment";
import Cookies from "js-cookie";
export default {
  components: {
    Fragment,
  },
  props: ["informacioncliente"],
  data() {
    return {
      appsData: {
        "Lem Tech": {
          icon: "fas fa-hand-holding-water",
          color: "#0081B8",
        },
        "Frio Invernal": {
          icon: "fas fa-snowflake",
          color: "#0081B8", 
        },
        "Comparacion": {
          icon: "fas fa-chart-line",
          color: "#0081B8",
        },
        "Aplicación DPV": {
          icon: "fas fa-stream",
          color: "#0081B8",
        },
        "Grados dia": {
          icon: "fas fa-thermometer-half",
          color: "#0081B8",
        },
        "Riego milimetro": {
          icon: "fas fa-tint",
          color: "#51879E",
        },
        "Lem Caudal": {
          icon: "fas fa-tint",
          color: "#22A159",
        },
        "Lem Pozo": {
          icon: "fas fa-tint",
          color: "#0081B8",
        },
        "Estacion Meteorológica": {
          icon: "fas fa-cloud-sun",
          color: "#0081B8",
        },
        "Riego Normalizado": {
          icon: "fas fa-tint",
          color: "#0081B8",
        },
        "Smart Graphics Lem": {
          icon: "fas fa-chart-bar",
          color: "#22A159",
        },
        "Pronóstico riego": {
          icon: "fas fa-magic",
          color: "#0081B8",
        },
        "Gráfico": {
          icon: "fas fa-chart-bar",
          color: "#0081B8",
        },
        "LemBox": {
          icon: "fas fa-project-diagram",
          color: "#0081B8",
        },
        "LemControl": {
          icon: "fas fa-faucet",
          color: "#0081B8",
        },
      },
    };
  },

  components: {
    IconButton,
  },

  computed: {
    informacionElemento(){
      return this.$store.state.aplicaciones.informacionElemento;
    },
    aplicacionesCliente() {
      return this.$store.state.aplicaciones.aplicacionesCliente;
    },
    etiquetaNodo(){
      return this.$store.state.aplicaciones.nombreNodo;
    },
    appsCliente() {
      if (!this.aplicacionesCliente) {
        return null;
      }

      return this.aplicacionesCliente.map((appCliente) => {
        if (appCliente.id_sig_subobjeto && this.informacionElemento.id_sig_subobjeto !== appCliente.id_sig_subobjeto) {
          return null;
        }

        let appData;
        if (appCliente.nombre.startsWith("Gráfico")) {
          appData = this.appsData["Gráfico"];
        } else {
          appData = this.appsData[appCliente.nombre];
        }

        if (appData) {
          let appWithUrlAndToken = { ...appData };
          appWithUrlAndToken.nombre = appCliente.nombre;
          appWithUrlAndToken.url = appCliente.url;
          appWithUrlAndToken.post = appCliente.post;
          if (!appWithUrlAndToken.post.api_token) {
            appWithUrlAndToken.post.api_token = Cookies.get("tokenSig");
          }
          return appWithUrlAndToken;
        }

        return null;
      }).filter(app => app !== null);
    },
  },

  methods: {
    abrirPestana(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.rightItemContainer div {
  margin: 0px;
  height: 100%;
  width: 100%;
  text-align: center;
  line-height: 75px;
  font-size: 30px;
  border: 1px solid black;
}
</style>
